import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const withdrawalHistorySchema = z.object({
  /** Order ID */
  orderId: z.string(),
  /** トランザクションID（`dest` が `on_chain` の場合はオンチェーンハッシュ、`internal_transfer` の場合はトレードID） */
  tradeId: z.string(),
  /** トークン名 */
  coin: z.string(),
  /** クライアントカスタムID */
  clientOid: z.string().nullable().optional(),
  /** 出金タイプ（固定値：withdraw） */
  type: z.string(),
  /** 出金の種類（`on_chain`: オンチェーン出金、`internal_transfer`: 内部振替） */
  dest: z.string(),
  /** 出金数量 */
  size: decimalSchema,
  /** 出金手数料 */
  fee: decimalSchema,
  /** 出金ステータス（`pending`, `fail`, `success`） */
  status: z.union([
    z.literal('pending'),
    z.literal('fail'),
    z.literal('success'),
  ]),
  /** 出金元アドレス（`on_chain`: オンチェーンアドレス、`internal_transfer`: UID/メール/電話番号） */
  fromAddress: z.string(),
  /** 出金先アドレス（`on_chain`: オンチェーンアドレス、`internal_transfer`: UID/メール/電話番号） */
  toAddress: z.string(),
  /** 出金ネットワーク（`internal_transfer` の場合は無視） */
  chain: z.string(),
  /** 承認済ブロック数 */
  confirm: z.string(),
  /** タグ */
  tag: z.string().nullable().optional(),
  /** 作成時間（ミリ秒） */
  cTime: z.string(),
  /** 更新時間（ミリ秒） */
  uTime: z.string(),
})

export const responseSchema = z.object({
  /** Response code, `00000` for success */
  code: z.string(),
  /** Response message, `success` for success */
  msg: z.string(),
  /** Request time in milliseconds */
  requestTime: z.number(),
  /** 出金データの配列 */
  data: z.array(withdrawalHistorySchema),
})
